<template>
  <div :class="classInput">
    <div class="form-group">
      <label class="label" :class="{'required': isRequired, 'is-invalid': isInvalid}">{{ label }}</label>
      <div class="inline-radio">
        <div v-for="opt in options" :key="opt.value">
            <input
              type="radio"
              :name="'radio-' + id"
              :id="'radio-' + id + '-' + opt.value"
              :value="opt.value"
              :checked="String(value) === String(opt.value)"
              class="my10x5"
              @blur="() => validate()"
              @change="handleChange($event.target.value)"
            >
            <label :for="'radio-' + id + '-' + opt.value">{{ opt.label }}</label>
        </div>
      </div>
      <div
        v-if="isInvalid"
        class="invalid-feedback"
      >
        <span v-if="isInvalid">Campo obrigatório.</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: [Number, String],
      required: true
    },
    label: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      required: true,
      validator (opts) {
        return !opts.find(opt => typeof opt !== 'object')
      }
    },
    value: {
      type: [String, Number, Boolean],
      default: ''
    },
    classInput: {
      type: String,
      required: true
    },
    isRequired: {
      type: Boolean,
      default: true
    },
    forceShowError: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isInvalid: false,
      hasTouched: false
    }
  },
  watch: {
    forceShowError (newVal) {
      if (newVal) {
        this.validate()
      }
    }
  },
  methods: {
    handleChange (value) {
      this.hasTouched = true

      // Se o campo estava com erro e o usuário selecionou algo, limpar o erro imediatamente
      if (this.isInvalid && value && value !== '') {
        this.isInvalid = false
      }

      this.$emit('input', value)
    },
    validate () {
      const shouldValidate = this.hasTouched || this.forceShowError
      this.isInvalid = shouldValidate && this.isRequired && (!this.value || this.value === '')
    },
    isValid () {
      this.validate()
      return !this.isInvalid
    }
  }
}
</script>
<style scoped>
.my10x5 {
  margin: 10px 5px;
}
.inline-radio {
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 10px;
}
</style>
